/**
 * @link      https://karmabunny.com.au
 * @copyright Copyright (c) 2023 Karmabunny
 */
import { API } from "./base";
import { PackageSlot, ReservableItem } from "../types";

const api = new API();


/**
 * Hits the `#[Route('{uid}/products')]` in the Reservable controller in TheyStay/API returning
 * a list of ReservableItems belonging to the provided entity.
 */
export async function getReservableItems(entity_uid?: string) {
    entity_uid ??= api.config.base_entity_uid;

    const res = await api.call({
        method: 'GET',
        endpoint: `/reservable/${entity_uid}/products`,
    });

    return res.items as ReservableItem[];
}


/**
 * Hits the `#[Route('package-slots-available/{package_uid}')]` in the Reservable controller in TheyStay/API returning
 * a list of ReservableItems belonging to the provided entity.
 */
export async function getReservablePackageTimesAvailable(package_uid: string, start_date: string, end_date: string, qty: number) {
    const res = await api.call({
        method: 'GET',
        endpoint: `/reservable/package-slots-available/${package_uid}`,
        query: {
            start: start_date,
            end: end_date,
            qty: qty,
        }
    });

    return res as PackageSlot[];
}


/**
 * Hits the `#[Route('product/{product_uid}')]` in the ReservableApi controller in TheyStay/API returning
 * a single Reservable item.
 */
export async function getSingleReservableItem(reservableitem_uid: string) {
    const res = await api.call({
        method: 'GET',
        endpoint: `/reservable/product/${reservableitem_uid}`,
    });

    return res.product as ReservableItem;
}


export async function createReservableBooking(form: any) {
    let {base_entity_uid} = api.config;

    const res = await api.call({
        method: 'POST',
        endpoint: `/reservable/${base_entity_uid}/hire-order-create`,
        body: form
    })

    return res;
}